import { db } from '@/database/firebase.db';
import { IBooking } from '@/models/IBooking.model';
export class BookingAPI {
    private db;
    private collection;
    constructor(){
        this.db = db;
        this.collection = this.db.collection('bookings');
    }
    async getAll(): Promise<IBooking[]>{
        const bookingQuery = this.collection.doc('SUMMARY');
        const bookingSnapshot = await bookingQuery.get();
        const bookingDocument = bookingSnapshot.data();
        if(bookingDocument){
            return Object.values(bookingDocument);
        } else {
            return []
        }  
    }
    async getById(id: string){
        const bookingQuery = this.collection.doc(id);
        const bookingSnapshots = (await bookingQuery.get());
        const bookingSnapshotsDoc = bookingSnapshots.data();
        if(bookingSnapshotsDoc){
            return bookingSnapshotsDoc;
        } else {
            return null
        }    
    }
    async getAllByParkName(parkName: string): Promise<IBooking[]>{

        console.clear()
        const bookingQuery = this.collection;
        const bookingSnapshots = (await bookingQuery.where("parkName", "==", parkName).get());
        const bookingSnapshotsDocs = bookingSnapshots.docs;
        const bookingDocuments = bookingSnapshotsDocs.map(bookingSnapshots => bookingSnapshots.data());

        if(bookingDocuments){
            return bookingDocuments;
        } else {
            return []
        }  
    }
    async patch(booking: IBooking): Promise<IBooking>{
     
        // Add booking
        const bookingId = booking.id;
        const bookingQuery = this.collection.doc(bookingId);
        const bookingSnapshot = await bookingQuery.update(booking);

        // Update Summary
        try {
            const bookingsQuery = this.collection.doc('SUMMARY');
            const bookingsSnapshot = await bookingsQuery.get();
            const bookingsDocument = bookingsSnapshot.data();
            if (bookingsDocument) {
                const summarybookings = bookingsDocument;
                summarybookings[bookingId] = booking;
                await this.collection.doc('SUMMARY').set(summarybookings);
            } else {
                throw 'Error Updating booking.Summary'
            }
        } catch (err) {
            console.error(err)
        }
        return booking;
    }
    async post(booking: IBooking): Promise<IBooking>{
     
        // Add booking
        const bookingId = booking.id;
        const bookingQuery = this.collection.doc(bookingId);
        const bookingSnapshot = await bookingQuery.set(booking);

        // Update Summary
        try {
            const bookingsQuery = this.collection.doc('SUMMARY');
            const bookingsSnapshot = await bookingsQuery.get();
            const bookingsDocument = bookingsSnapshot.data();
            if (bookingsDocument) {
                const summarybookings = bookingsDocument;
                summarybookings[bookingId] = booking;
                await this.collection.doc('SUMMARY').set(summarybookings);
            } else {
                throw 'Error Updating booking.Summary'
            }

        } catch (err) {
            console.error(err)
        }
        return booking;
    }
    async delete(booking: IBooking): Promise<IBooking>{
     
        // Add booking
        const bookingId = booking.id;
        const bookingQuery = this.collection.doc(bookingId);
        const bookingSnapshot = await bookingQuery.delete();

        // Update Summary
        try {
            const bookingsQuery = this.collection.doc('SUMMARY');
            const bookingsSnapshot = await bookingsQuery.get();
            const bookingsDocument = bookingsSnapshot.data();
            if (bookingsDocument) {
                const summarybookings = bookingsDocument;
                delete summarybookings[bookingId];
                await this.collection.doc('SUMMARY').set(summarybookings);
            } else {
                throw 'Error Updating booking.Summary'
            }
        } catch (err) {
            console.error(err)
        }
        return booking;
    }
    async getByDateAndParkAndCC(ddmmyyyy: string, parkName: string, cc: string){

        console.clear()
        const bookingQuery = this.collection.where("cc_number", "==", cc).where("parkName", "==", parkName).where("ddmmyyyy", "==", ddmmyyyy);
        const bookingSnapshots = (await bookingQuery.get());
        const bookingSnapshotsDocs = bookingSnapshots.docs;
        const bookingDocuments = bookingSnapshotsDocs.map(bookingSnapshots => bookingSnapshots.data());

        console.error('bookingsDocumetnts **')
        console.error(bookingDocuments)

        
        if(bookingDocuments){
            return bookingDocuments;
        } else {
            return []
        }  
    }
   
} 